export default __webpack_public_path__ + "static/media/donut-sushiswap.4d88631c.png";